import { useRef, useState, useCallback } from 'react';

export function useYouTubePlayer() {
  const playerRef = useRef(null);

  const [playerLoaded, setPlayerLoaded] = useState(false);
  const [videoVisible, setVideoVisible] = useState(false);
  const [mute, setMute] = useState(false);

  const onVideoReady = useCallback((event) => {
    playerRef.current = event.target;
    setPlayerLoaded(true);
  }, []);

  const playVideo = useCallback(() => {
    if (playerRef.current) {
      playerRef.current.playVideo();
    }
  }, []);

  const pauseVideo = useCallback(() => {
    if (playerRef.current) {
      playerRef.current.pauseVideo();
    }
  }, []);

  const hideVideo = useCallback(() => {
    setVideoVisible(false);
    if (playerRef.current) {
      playerRef.current.mute();
    }
  }, []);

  const showVideo = useCallback(() => {
    setVideoVisible(true);
    if (playerRef.current && !mute) {
      playerRef.current.unMute();
    }
  }, [mute]);

  const toggleMute = useCallback(() => {
    setMute((prev) => {
      const newMute = !prev;
      if (playerRef.current) {
        if (newMute) {
          playerRef.current.mute();
        } else {
          playerRef.current.unMute();
        }
      }
      return newMute;
    });
  }, []);

  const getPlayerState = useCallback(() => {
    if (!playerRef.current) return undefined;
    return playerRef.current.getPlayerState();
  }, []);

  return {
    // refs
    playerRef,

    // state
    playerLoaded,
    videoVisible,
    mute,

    // handlers
    onVideoReady,
    playVideo,
    pauseVideo,
    hideVideo,
    showVideo,
    toggleMute,
    getPlayerState,

    // internal setters if needed
    setVideoVisible,
  };
}
